import { env } from "@roman/shared/config/env";

/**
 * Environment detection utility for both mobile and web platforms
 */

// Mobile environment detection (safe for browser)
const mobileEnv = env.APP_ENV;

// Platform detection
const isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined";

// Web environment detection (browser only)
const isWebProd = isBrowser && window.location.hostname === "thumba.jp";

// Combined production check
const isProd = mobileEnv === "production" || isWebProd;

export const environment = {
  // Mobile specific
  mobile: {
    env: mobileEnv,
    isProd: mobileEnv === "production",
    isStg: mobileEnv === "staging",
    isLocal: mobileEnv === "local",
  },

  // Web specific
  web: {
    isProd: isWebProd,
    isDev: isBrowser && !isWebProd,
    hostname: isBrowser ? window.location.hostname : undefined,
  },

  // Combined
  isProd,
  isDev: !isProd,

  // Platform detection
  isBrowser,
  isMobile: !isBrowser,
} as const;
